import { AsyncPipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input } from '@angular/core';
import { ElementHostComponent } from '@components/element-widgets/element-host/element-host.component';
import { GridLayoutComponent } from '@components/layouts/grid-layout/grid-layout.component';
import { HorizontalLayoutComponent } from '@components/layouts/horizontal-layout/horizontal-layout.component';
import { ProvideElementsDirective } from 'src/app/element-handling/provide-elements.directive';
import { ElementPipe } from '../../../element-handling/element.pipe';
import { RouteSelectedFund } from '../selected-fund';

@Component({
  selector: 'wct-fondsportrait-header',
  standalone: true,
  imports: [
    AsyncPipe,
    ElementPipe,
    ProvideElementsDirective,
    ElementHostComponent,
    GridLayoutComponent,
    HorizontalLayoutComponent,
  ],
  templateUrl: './fondsportrait-header.component.html',
  styleUrl: './fondsportrait-header.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FondsportraitHeaderComponent {
  @Input({ required: true }) public documentId!: string;
  @Input({ required: false }) public reportIndex: number = 0;

  protected selectedFund = inject(RouteSelectedFund);
}
